"use client";

import { SnackbarProvider } from "notistack";
import type { ReactNode } from "react";
import { Toast } from "../ui/toast";

export function ToastProvider({ children }: Readonly<{ children: ReactNode }>) {
	return (
		<SnackbarProvider
			maxSnack={3}
			anchorOrigin={{ horizontal: "right", vertical: "top" }}
			Components={{
				default: (props) => <Toast ref={props.ref} message={props.message} />,
				info: (props) => (
					<Toast ref={props.ref} severity="info" message={props.message} />
				),
				warning: (props) => (
					<Toast ref={props.ref} severity="warning" message={props.message} />
				),
				success: (props) => (
					<Toast ref={props.ref} severity="success" message={props.message} />
				),
				error: (props) => (
					<Toast ref={props.ref} severity="error" message={props.message} />
				),
			}}
		>
			{children}
		</SnackbarProvider>
	);
}
